import {
  IElementBase,
  IElementGenericPointCloudStream,
  isIElementGaussianSplats,
  isIElementGaussianSplatsPly,
  isIElementGenericPointCloudStream,
  type IElementGaussianSplats,
} from "@faro-lotv/ielement-types";

/**
 * @returns True if the given iElement is a streamed point cloud
 * @param iElement element to check
 */
export function isIElementValidPointCloudStream(
  iElement: IElementBase,
): iElement is IElementGenericPointCloudStream {
  return isIElementGenericPointCloudStream(iElement);
}

/**
 * @returns True if the given iElement is a Gaussian splats that can be shown in the viewer
 * @param iElement element to check
 */
export function isIElementViewableGaussianSplats(
  iElement: IElementBase,
): iElement is IElementGaussianSplats {
  return (
    isIElementGaussianSplats(iElement) && !isIElementGaussianSplatsPly(iElement)
  );
}
